const REPORT_PROD_BASE = "https://hzshixiang.site/report/prod";

/**
 * 鉴别作业行 → 小程序 jbReport 报告页二维码链接。
 *
 * 注意：二维码 id 使用业务订单主键 orderId（xw_order / secondhand_order），
 * 不是鉴别作业表主键 id。
 *
 * 香水订单（作业 orderType 1/2）仅传 id，小程序按 reportIssuedAt 自动选模板；
 * 闲置（orderType 3）用 t=1；安心购（orderType 4）用 t=2，走二手订单报告接口。
 */
export function buildInspectionJobReportQrUrl(row) {
  if (!row || row.orderId == null) return "";
  const orderId = row.orderId;
  const jobOrderType = Number(row.orderType);
  const base = `${REPORT_PROD_BASE}?id=${orderId}`;
  if (jobOrderType === 3) {
    return `${base}&t=1`;
  }
  if (jobOrderType === 4) {
    return `${base}&t=2`;
  }
  return base;
}

/** 标签侧六位数字：取订单号末六位（与鉴别订单列表「鉴别报告打印」一致） */
export function inspectionJobReportLabelSuffix(row) {
  const orderNoStr = row && row.orderNo != null ? String(row.orderNo) : "";
  return orderNoStr.slice(-6);
}

/** 是否已出具鉴别结论，可打印报告二维码 */
export function canPrintInspectionJobReport(row) {
  if (!row || row.orderId == null) return false;
  const result = Number(row.result);
  return result === 1 || result === 2;
}

/** 闲置 / 安心购作业（orderType 3 / 4） */
export function isSecondhandJobOrderType(orderType) {
  const n = Number(orderType);
  return n === 3 || n === 4;
}

/** 是否可在后台修改已出具的鉴别结果 */
export function canEditInspectionResult(row) {
  if (!row || row.orderId == null) return false;
  const result = Number(row.result);
  if (result !== 1 && result !== 2) return false;
  const status = Number(row.status);
  // 3=待评级 4=待发货 5=已完成（报告已出具后均可修改鉴别内容）
  if (status < 3) return false;

  const orderType = Number(row.orderType);
  if (orderType === 4) {
    if (result !== 1) return false;
    if (row.sourceInspectionBuyerDecision != null && Number(row.sourceInspectionBuyerDecision) !== 0) {
      return false;
    }
  }
  if (orderType === 1 || orderType === 2) {
    const orderStatus = row.sourceOrderStatus != null ? Number(row.sourceOrderStatus) : null;
    // 5=已退款 10=已取消
    if (orderStatus === 5 || orderStatus === 10) return false;
  }
  return true;
}

/** 是否可在后台预览小程序同款报告模板 */
export function canPreviewInspectionJobReport(row) {
  if (!row || row.orderId == null) return false;
  if (canPrintInspectionJobReport(row)) return true;
  const ot = Number(row.orderType);
  if (isSecondhandJobOrderType(ot) && Number(row.status) >= 4) return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/util/inspectionReportQr.js